/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { LedgerItemUpdate } from './LedgerItemUpdate.js';
import {
    LedgerItemUpdateFromJSON,
    LedgerItemUpdateFromJSONTyped,
    LedgerItemUpdateToJSON,
} from './LedgerItemUpdate.js';

/**
 * 
 * @export
 * @interface RuleUpdate
 */
export interface RuleUpdate {
    /**
     * 
     * @type {number}
     * @memberof RuleUpdate
     */
    ruleId?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleUpdate
     */
    points?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RuleUpdate
     */
    isDisabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RuleUpdate
     */
    disableReason?: string;
    /**
     * 
     * @type {string}
     * @memberof RuleUpdate
     */
    notes?: string;
    /**
     * 
     * @type {Array<LedgerItemUpdate>}
     * @memberof RuleUpdate
     */
    ledgerItems?: Array<LedgerItemUpdate>;
}

/**
 * Check if a given object implements the RuleUpdate interface.
 */
export function instanceOfRuleUpdate(value: object): boolean {
    return true;
}

export function RuleUpdateFromJSON(json: any): RuleUpdate {
    return RuleUpdateFromJSONTyped(json, false);
}

export function RuleUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'ruleId': json['ruleId'] == null ? undefined : json['ruleId'],
        'points': json['points'] == null ? undefined : json['points'],
        'isDisabled': json['isDisabled'] == null ? undefined : json['isDisabled'],
        'disableReason': json['disableReason'] == null ? undefined : json['disableReason'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'ledgerItems': json['ledgerItems'] == null ? undefined : ((json['ledgerItems'] as Array<any>).map(LedgerItemUpdateFromJSON)),
    };
}

export function RuleUpdateToJSON(value?: RuleUpdate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ruleId': value['ruleId'],
        'points': value['points'],
        'isDisabled': value['isDisabled'],
        'disableReason': value['disableReason'],
        'notes': value['notes'],
        'ledgerItems': value['ledgerItems'] == null ? undefined : ((value['ledgerItems'] as Array<any>).map(LedgerItemUpdateToJSON)),
    };
}

